import React, { useEffect, useRef, useState } from "react";
import ProgressBarBottom from "../../components/Booking/ProgressBarBottom";

// const defaultSteps = [

//               "Upload images",
//               "Items",
//               "Locations",
//               "Date & Time",
//               "Truck & crew",
//               "Personal info",
//               "Contact info",
//               "Order Confirmation",
          
// ];

const BookingProgress = ({ currentStep, customSteps }) => {
  const steps = customSteps
  const containerRef = useRef(null);
  const activeTabRef = useRef(null);

  // Use window width to determine mobile breakpoint instead of hook
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1024
  );
  useEffect(() => {
    const onResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const isMobileDevice = width < 768;

  // Keep desktop behavior: center the active tab by scrolling container.
  // On mobile we disable scrolling and reorder items so active is first.
  useEffect(() => {
    if (isMobileDevice) return; // no scrolling on mobile
    if (activeTabRef.current && containerRef.current) {
      const container = containerRef.current;
      const activeTab = activeTabRef.current;

      const containerWidth = container.offsetWidth;
      const tabLeft = activeTab.offsetLeft;
      const tabWidth = activeTab.offsetWidth;

      const scrollLeft = tabLeft - containerWidth / 2 + tabWidth / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: "smooth",
      });
    }
  }, [currentStep, isMobileDevice]);

  return (
    <div className="flex flex-col w-full overflow-x-hidden overflow-y-hidden">
      <div
        ref={containerRef}
        className={`flex justify-start gap-x-[14px] md:justify-between`}
        style={{ paddingBottom: "0px" }}
      >
        {
          // On mobile reorder steps so the active one is first and following steps come after.
          // This hides previous steps (they are rendered after the visible ones) and prevents scrolling.
          (isMobileDevice
            ? steps.slice(currentStep) // only render active and following steps on mobile
            : steps
          )?.map((step, i) => {
            const originalIndex = isMobileDevice ? currentStep + i : i;
            const isActive = originalIndex === currentStep;
            const isCompleted = originalIndex <= currentStep;

            return (
              <div
                key={originalIndex}
                ref={!isMobileDevice && isActive ? activeTabRef : null}
                className={`flex items-center  md:py-2 py-[4px] transition-all duration-300 ease-in-out relative flex-shrink-0 whitespace-nowrap`}
              >
                <span
                  className={`md:text-sm text-[12px] font-instrument whitespace-nowrap text-center ${
                    isCompleted
                      ? "font-semibold text-[#211F59]"
                      : "text-[#7876A1] font-[500]"
                  }`}
                >
                  {step}
                </span>
              </div>
            );
          })
        }
      </div>
      <div className="w-full">
        <ProgressBarBottom
          currentStep={currentStep}
          totalSteps={steps.length}
        />
      </div>
    </div>
  );
};

export default BookingProgress;
